import React, { memo } from 'react'
import styles from './button.module.css'

const Button = ({children, onClick, style , buttonType , id , disabled}) => {
    return <button className={!buttonType ? styles.btn : styles.whtBtn} onClick={onClick} style={style} id={id} disabled={disabled}> {children} </button>
}

export default memo(Button) ;